// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notification-collapse-header[data-v-096fc840]{cursor:pointer;color:orange;margin-bottom:10px}.notification-collapse-header i[data-v-096fc840]{margin-right:10px}.alert[data-v-096fc840]{margin-bottom:5px}.helpdesk-chat-link[data-v-096fc840]{font-size:16px;border:none;background:none;cursor:pointer;padding:0;color:#0696d7;text-decoration:underline}", ""]);
// Exports
module.exports = exports;
